import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import sortBy from 'lodash.sortby';
import get from 'lodash.get';

// Components
import PinterestAccountSettings from '../Pinterest/PinterestAccountSettings';
import FacebookAccountSettings from '../Facebook/FacebookAccountSettings';

class AccountSettings extends React.Component {
    render() {
        const { viewer, user } = this.props;
        const { socialNetworks, isFacebookEnabled } = viewer || {};

        return (
            <div>
                {sortBy(socialNetworks, ['serviceId']).map(socialNetwork => {
                    const { name, serviceId, parameters: { clientId } } = socialNetwork;

                    switch (name) {
                        case 'PINTEREST':
                            return (
                                <PinterestAccountSettings
                                    key={serviceId}
                                    userId={user.serviceId}
                                    clientId={clientId}
                                    userSocialNetwork={get(
                                        user,
                                        'pinterestUserSocialNetwork.0',
                                        null
                                    )}
                                />
                            );
                        case 'FACEBOOK':
                            return isFacebookEnabled ? (
                                <FacebookAccountSettings
                                    key={serviceId}
                                    userId={user.serviceId}
                                    userSocialNetwork={get(
                                        user,
                                        'facebookUserSocialNetwork.0',
                                        null
                                    )}
                                />
                            ) : null;
                    }

                    return null;
                })}
            </div>
        );
    }
}

AccountSettings.propTypes = {
    viewer: PropTypes.shape({
        isFacebookEnabled: PropTypes.bool,
        socialNetworks: PropTypes.array.isRequired,
    }),
    user: PropTypes.object,
};

AccountSettings = createFragmentContainer(AccountSettings, {
    viewer: graphql`
        fragment AccountSettings_viewer on Viewer {
            isFacebookEnabled: isEnabled(key: "facebookConnection")
            socialNetworks {
                serviceId
                name
                parameters {
                    clientId
                }
            }
        }
    `,
    user: graphql`
        fragment AccountSettings_user on User {
            serviceId
            facebookUserSocialNetwork: socialNetworks(socialNetworkNames: [FACEBOOK]) {
                ...FacebookAccountSettings_userSocialNetwork
            }
            pinterestUserSocialNetwork: socialNetworks(socialNetworkNames: [PINTEREST]) {
                ...PinterestAccountSettings_userSocialNetwork
            }
        }
    `,
});

export default AccountSettings;



// WEBPACK FOOTER //
// ./assets/js/global/components/SocialNetworks/AccountSettings.jsx